import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../../Shared/pr-s-black';
import '../../Assets/Stylesheets/Pages/Blog/Blog.scss';
import { API_BASE_URL } from '../../config/api';

export default function BlogPage() {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  useEffect(() => {
    fetchBlogPosts();
  }, []);

  const fetchBlogPosts = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/blog/posts`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch blog posts');
      }
      
      const data = await response.json();
      
      if (data.success) {
        setBlogPosts(data.posts);
      } else {
        setError(data.error || 'Failed to load blog posts');
      }
    } catch (err) {
      console.error('Error fetching blog posts:', err);
      setError('Unable to load blog posts. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="blog-page">
        <Particles
          id="tsparticles"
          init={particlesInit}
          options={particlesConfig}
          className="particles-background"
        />
        <div className="blog-content">
          <h1>Loading...</h1>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-page">
        <Particles
          id="tsparticles"
          init={particlesInit}
          options={particlesConfig}
          className="particles-background"
        />
        <div className="blog-content">
          <h1>Blog</h1>
          <p className="error-message">{error}</p>
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return { day: '00', month: 'Month' };
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleDateString('en-US', { month: 'long' });
    return { day, month };
  };

  return (
    <div className="blog-page">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={particlesConfig}
        className="particles-background"
      />
      <div className="blog-content">
        <h1>Blog</h1>
        
        <section className="blog-section">
          <h2>Latest Articles</h2>
          {blogPosts.length === 0 ? (
            <p>No blog posts available yet. Check back soon!</p>
          ) : (
            <div className="blog-list-container">
              {blogPosts.map((blogItem) => {
                const date = formatDate(blogItem.published_at);
                return (
                  <div className="blog-article-row" key={blogItem.id}>
                    <div className="blog-list">
                      <div className="blog-image">
                        <img 
                          src={blogItem.featured_image || '/img/blog-placeholder1.jpg'} 
                          alt={blogItem.title} 
                        />
                      </div>
                      <div className="blog-details">
                        <div className="info">
                          <span>
                            <i>{date.day}</i> {date.month}
                          </span>
                          <span> / </span>
                          <span>{blogItem.author}</span>
                        </div>
                        <div className="blog-article-title">
                          <h5>
                            <Link to={`/blog/${blogItem.slug}`}>
                              {blogItem.title}
                            </Link>
                          </h5>
                        </div>
                        {blogItem.excerpt && (
                          <div className="blog-excerpt">
                            <p>{blogItem.excerpt}</p>
                          </div>
                        )}
                        {blogItem.tags && blogItem.tags.length > 0 && (
                          <div className="blog-tags">
                            {blogItem.tags.map((tag, index) => (
                              <span key={index} className="tag">{tag}</span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}